import React from 'react';
import { Routes, Route } from "react-router-dom";
import AdminLoListingCalendar from './lo-listing-calendar/admin-lo-listing-calendar';

const AdminListingCalendar = () => {
  return (
    <Routes>
      <Route index element={<AdminLoListingCalendar />} />
    </Routes>
  )
}

export default AdminListingCalendar;
